
const Spinner = () => {
    return (
        <div className="text-center">
            Loading...
            <div className="spinner" />
        </div>
    )
}
export default Spinner

